import { createRouter, createWebHistory } from "vue-router";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import YuklamaJadval from "@/views/yuklamaJadval.vue";
import KafedraYuklamalari from "@/views/KafedraYuklamalari.vue";
import IshchiOquvRejalar from "@/views/IshchiOquvRejalar.vue";
import KafedraTaqsimoti from "@/views/KafedraTaqsimoti.vue";
import TanlovFanlar from "@/views/TanlovFanlar.vue";
import ShaxsiyIshReja from "@/views/ShaxsiyIshReja.vue";
import ShaxsiyIshRejaDetail from "@/views/ShaxsiyIshRejaDetail.vue";
import KafedraVsShaxsiyReja from "@/views/KafedraVsShaxsiyReja.vue";
import YuklamaVaTaqsimot from "@/views/YuklamaVaTaqsimot.vue";
import FaoliyatJurnali from "@/views/FaoliyatJurnali.vue";
import Backup from "@/views/Backup.vue";
import TaqsimotJadval from "@/views/TaqsimotJadval.vue";
import KafedraOqituvchilari from "@/views/KafedraOqituvchilari.vue";
import OqituvchiIshi from "@/views/OqituvchiIshi.vue";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/Login.vue"),
    },
    {
      path: "/hemis/callback",
      name: "hemis-callback",
      component: () => import("@/views/HemisCallback.vue"),
    },
    {
      path: "/verify/shaxsiy-reja/:employeeId",
      name: "verify-shaxsiy-reja",
      component: () => import("@/views/PublicShaxsiyRejaVerify.vue"),
      meta: { public: true }
    },
    {
      path: "/",
      component: DefaultLayout,
      children: [
        {
          path: "",
          redirect: { name: "kafedra-yuklamalari" },
        },
        {
          path: "kafedra-yuklamalari",
          name: "kafedra-yuklamalari",
          component: KafedraYuklamalari,
          meta: { breadcrumb: "Kafedra yuklamalari" },
        },
        {
          path: "ishchi-oquv",
          name: "ishchi-oquv",
          component: IshchiOquvRejalar,
          meta: { breadcrumb: "O'quv reja" },
        },
        {
          path: "talabalar",
          name: "talabalar",
          component: () => import("@/views/Talabalar.vue"),
          meta: { breadcrumb: "Talabalar" },
        },
        {
          path: "kadrlar",
          name: "kadrlar",
          component: () => import("@/views/Kadrlar.vue"),
          meta: { breadcrumb: "Kadrlar bo'limi" },
        },
        {
          path: "kafedra-taqsimoti",
          name: "kafedra-taqsimoti",
          component: KafedraTaqsimoti,
          meta: { breadcrumb: "Kafedra taqsimoti" },
        },
        {
          path: "sozlamalar",
          name: "sozlamalar",
          component: () => import("@/views/Sozlamalar.vue"),
          meta: { breadcrumb: "Sozlamalar", oquvSuperAdminOnly: true },
        },
        {
          path: "tanlov-fanlar",
          name: "tanlov-fanlar",
          component: TanlovFanlar,
          meta: { breadcrumb: "Tanlov fanlar" },
        },
        {
          path: "tanlov-fanlar/oqituvchilar",
          name: "tanlov-fanlar-oqituvchilar",
          component: KafedraOqituvchilari,
          meta: { breadcrumb: "O'qituvchilar" },
        },
        {
          path: "tanlov-fanlar/oqituvchilar/ishi",
          name: "oqituvchi-ishi",
          component: OqituvchiIshi,
          meta: { breadcrumb: "O'qituvchi ishi" },
        },
        { path: "yuklama-jadval", name: "yuklama-jadval", component: YuklamaJadval },
        { path: "taqsimot-jadval", name: "taqsimot-jadval", component: TaqsimotJadval },
        { path: "shaxsiy-ish-reja", name: "shaxsiy-ish-reja", component: ShaxsiyIshReja },
        { path: "shaxsiy-ish-reja/:employeeId", name: "shaxsiy-ish-reja-detail", component: ShaxsiyIshRejaDetail },
        { 
          path: "kafedra-vs-shaxsiy-reja", 
          name: "kafedra-vs-shaxsiy-reja", 
          component: KafedraVsShaxsiyReja,
          meta: { breadcrumb: "Kafedra vs Shaxsiy ish reja", superAdminOnly: true }
        },
        { 
          path: "yuklama-va-taqsimot", 
          name: "yuklama-va-taqsimot", 
          component: YuklamaVaTaqsimot,
          meta: { breadcrumb: "Yuklama va taqsimot" }
        },
        { 
          path: "faoliyat-jurnali", 
          name: "faoliyat-jurnali", 
          component: FaoliyatJurnali,
          meta: { breadcrumb: "Faoliyat jurnali", superAdminOnly: true }
        },
        { 
          path: "backup", 
          name: "backup", 
          component: Backup,
          meta: { breadcrumb: "Baza nusxasi (Backup)", superAdminOnly: true }
        },
        // Oktyabr oyi yuklamalari yo'nalishlari
        {
          path: "oktyabr/kafedra-yuklamalari",
          name: "okt-kafedra-yuklamalari",
          component: KafedraYuklamalari,
          meta: { breadcrumb: "Kafedra yuklamalari (Oktyabr)", isOctober: true },
        },
        {
          path: "oktyabr/ishchi-oquv",
          name: "okt-ishchi-oquv",
          component: IshchiOquvRejalar,
          meta: { breadcrumb: "O'quv reja (Oktyabr)", isOctober: true },
        },
        {
          path: "oktyabr/kafedra-taqsimoti",
          name: "okt-kafedra-taqsimoti",
          component: KafedraTaqsimoti,
          meta: { breadcrumb: "Kafedra taqsimoti (Oktyabr)", isOctober: true },
        },
        {
          path: "oktyabr/tanlov-fanlar",
          name: "okt-tanlov-fanlar",
          component: TanlovFanlar,
          meta: { breadcrumb: "Tanlov fanlar (Oktyabr)", isOctober: true },
        },
        {
          path: "oktyabr/tanlov-fanlar/oqituvchilar",
          name: "okt-tanlov-fanlar-oqituvchilar",
          component: KafedraOqituvchilari,
          meta: { breadcrumb: "O'qituvchilar (Oktyabr)", isOctober: true },
        },
        {
          path: "oktyabr/tanlov-fanlar/oqituvchilar/ishi",
          name: "okt-oqituvchi-ishi",
          component: OqituvchiIshi,
          meta: { breadcrumb: "O'qituvchi ishi (Oktyabr)", isOctober: true },
        },
        { path: "oktyabr/yuklama-jadval", name: "okt-yuklama-jadval", component: YuklamaJadval, meta: { breadcrumb: "Yuklama jadval (Oktyabr)", isOctober: true } },
        { path: "oktyabr/taqsimot-jadval", name: "okt-taqsimot-jadval", component: TaqsimotJadval, meta: { breadcrumb: "Taqsimot jadval (Oktyabr)", isOctober: true } },
        { path: "oktyabr/shaxsiy-ish-reja", name: "okt-shaxsiy-ish-reja", component: ShaxsiyIshReja, meta: { breadcrumb: "Shaxsiy ish reja (Oktyabr)", isOctober: true } },
        { path: "oktyabr/shaxsiy-ish-reja/:employeeId", name: "okt-shaxsiy-ish-reja-detail", component: ShaxsiyIshRejaDetail, meta: { breadcrumb: "Shaxsiy ish reja tafsiloti (Oktyabr)", isOctober: true } },
        { 
          path: "oktyabr/kafedra-vs-shaxsiy-reja", 
          name: "okt-kafedra-vs-shaxsiy-reja", 
          component: KafedraVsShaxsiyReja,
          meta: { breadcrumb: "Kafedra vs Shaxsiy ish reja (Oktyabr)", superAdminOnly: true, isOctober: true }
        },
        { 
          path: "oktyabr/yuklama-va-taqsimot", 
          name: "okt-yuklama-va-taqsimot", 
          component: YuklamaVaTaqsimot,
          meta: { breadcrumb: "Yuklama va taqsimot (Oktyabr)", isOctober: true }
        },
        { 
          path: "oktyabr/faoliyat-jurnali", 
          name: "okt-faoliyat-jurnali", 
          component: FaoliyatJurnali,
          meta: { breadcrumb: "Faoliyat jurnali (Oktyabr)", superAdminOnly: true, isOctober: true }
        },
        { 
          path: "oktyabr/backup", 
          name: "okt-backup", 
          component: Backup,
          meta: { breadcrumb: "Baza nusxasi (Backup - Oktyabr)", superAdminOnly: true, isOctober: true }
        },
      ],
    },
  ],
});

import "@/utils/authStorage";

function hasValidAuth() {
  const token = sessionStorage.getItem("token") || localStorage.getItem("token");
  if (!token || token === "undefined" || token === "null" || !token.trim()) {
    return false;
  }
  const userStr = sessionStorage.getItem("user") || localStorage.getItem("user");
  if (!userStr || userStr === "undefined" || userStr === "null" || !userStr.trim()) {
    return false;
  }
  try {
    const user = JSON.parse(userStr);
    if (!user || typeof user !== "object") return false;
  } catch (e) {
    return false;
  }

  // Token muddati (JWT expiration) tekshiruvi: muddati o'tgan bo'lsa qaytadan login talab qilish
  try {
    const parts = token.split(".");
    if (parts.length === 3) {
      const payload = JSON.parse(atob(parts[1].replace(/-/g, "+").replace(/_/g, "/")));
      if (payload.exp && Date.now() >= payload.exp * 1000) {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("user");
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        return false;
      }
    }
  } catch (e) {}

  return true;
}

function getStoredUser() {
  try {
    const userStr = sessionStorage.getItem("user") || localStorage.getItem("user");
    if (!userStr || userStr === "undefined" || userStr === "null") return null;
    return JSON.parse(userStr);
  } catch (e) {
    return null;
  }
}

function isSuperAdminUser() {
  try {
    const user = getStoredUser();
    if (!user) return false;
    const role = (user.role || "").toString().toLowerCase().trim();
    return ["super admin", "superadmin", "admin", "administrator"].includes(role);
  } catch (e) {
    return false;
  }
}

function isDekanUser() {
  try {
    const user = getStoredUser();
    if (!user) return false;
    const role = (user.role || "").toString().toLowerCase().trim();
    if (isSuperAdminUser()) return false;
    return ["dekan", "dean", "fakultet dekani"].some(r => role.includes(r));
  } catch (e) {
    return false;
  }
}

function isKafedraMudirUser() {
  try {
    const user = getStoredUser();
    if (!user) return false;
    const role = (user.role || "").toString().toLowerCase().trim();
    if (isSuperAdminUser()) return false;
    return ["kafedra mudiri", "kafedra_mudiri", "mudir"].some(r => role.includes(r));
  } catch (e) {
    return false;
  }
}

function isTeacherUser() {
  try {
    const user = getStoredUser();
    if (!user) return false;
    const role = (user.role || "").toString().toLowerCase().trim();
    if (isSuperAdminUser() || isKafedraMudirUser() || isDekanUser()) return false;
    return [
      "qituvchi",
      "teacher",
      "assistent",
      "assistant",
      "dotsent",
      "docent",
      "professor",
      "stajyor",
      "foydalanuvchi",
      "user"
    ].some(r => role.includes(r));
  } catch (e) {
    return false;
  }
}

function isProrektorUser() {
  try {
    const user = getStoredUser();
    if (!user) return false;
    const role = (user.role || "").toString().toLowerCase().trim();
    return role.includes("prorektor");
  } catch (e) {
    return false;
  }
}

function isOquvSuperAdminUser() {
  try {
    const user = getStoredUser();
    if (!user) return false;
    const phone = (user.phone || "").toString().toLowerCase().trim();
    const name = (user.name || "").toString().toLowerCase().trim();
    return phone === "oquvsuperadmin" || name === "oquvsuper admin";
  } catch (e) {
    return false;
  }
}

router.beforeEach((to, from, next) => {
  // Ommaviy tekshirish sahifalariga loginsiz to'g'ridan-to'g'ri kirishga ruxsat
  if ((to.meta && to.meta.public) || to.path.startsWith("/verify/")) {
    return next();
  }

  const isAuth = hasValidAuth();

  // Login va parolsiz tizimdagi sahifalarga (shu jumladan /kafedra-yuklamalari ga) kirishni qat'iy taqiqlash
  if (to.name !== "login" && to.name !== "hemis-callback") {
    if (!isAuth) {
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      return next({ name: "login" });
    }
  }

  // Tizimga kirgan foydalanuvchi /login ga borsa, roliga qarab yo'naltirish
  if ((to.name === "login" || to.name === "hemis-callback") && isAuth) {
    if (isDekanUser() || isTeacherUser() || isProrektorUser()) {
      return next({ name: "shaxsiy-ish-reja" });
    } else if (isKafedraMudirUser()) {
      return next({ name: "kafedra-taqsimoti" });
    } else {
      return next({ name: "kafedra-yuklamalari" });
    }
  }

  // Bosh sahifa (/) ga kirganda roliga mos sahifaga yo'naltirish
  if (to.path === "/" && isAuth) {
    if (isDekanUser() || isTeacherUser() || isProrektorUser()) {
      return next({ name: "shaxsiy-ish-reja" });
    } else if (isKafedraMudirUser()) {
      return next({ name: "kafedra-taqsimoti" });
    } else {
      return next({ name: "kafedra-yuklamalari" });
    }
  }

  // Faqat oquvsuperadmin uchun ruxsat etilgan sahifalar (masalan: Sozlamalar)
  if (to.meta && to.meta.oquvSuperAdminOnly && !isOquvSuperAdminUser()) {
    return next({ path: "/" });
  }

  // SuperAdmin huquqi talab qilinadigan sahifalar
  if (to.meta && to.meta.superAdminOnly && !isSuperAdminUser()) {
    return next({ path: "/" });
  }

  // Kafedra mudiri uchun ruxsat etilgan sahifalar cheklovi: faqat Kafedra taqsimoti va Shaxsiy ish reja
  if (isAuth && isKafedraMudirUser()) {
    const allowedForMudir = [
      "kafedra-taqsimoti",
      "taqsimot-jadval",
      "yuklama-va-taqsimot",
      "shaxsiy-ish-reja",
      "shaxsiy-ish-reja-detail",
      "okt-kafedra-taqsimoti",
      "okt-taqsimot-jadval",
      "okt-yuklama-va-taqsimot",
      "okt-shaxsiy-ish-reja",
      "okt-shaxsiy-ish-reja-detail",
      "login",
      "hemis-callback"
    ];
    if (to.name && !allowedForMudir.includes(to.name)) {
      return next({ name: "kafedra-taqsimoti" });
    }
  }

  // Dekan, O'qituvchi va Prorektor uchun ruxsat etilgan sahifalar cheklovi: faqat Shaxsiy ish reja
  if (isAuth && (isDekanUser() || isTeacherUser() || isProrektorUser())) {
    const allowedForRestricted = [
      "shaxsiy-ish-reja",
      "shaxsiy-ish-reja-detail",
      "okt-shaxsiy-ish-reja",
      "okt-shaxsiy-ish-reja-detail",
      "login",
      "hemis-callback"
    ];
    if (to.name && !allowedForRestricted.includes(to.name)) {
      return next({ name: "shaxsiy-ish-reja" });
    }
  }

  next();
});

export default router;

